import React, { useEffect, useState } from "react";
import routeicon from "@/assets/routicon_colored.svg";
import phone from "@/assets/phone_colored.svg";
import global from "@/assets/global-colored.svg";
import clock from "@/assets/clock.svg";
import owl from "@/assets/owl-colored.svg";
import telephone from "@/assets/telephone.svg";
import mail from "@/assets/mail.svg";
import calendar from "@/assets/calendar.svg";
import { SinglePageData } from "@/types";
import WorkingHours from "./WorkingHours";
import { openMapsFromGeolocation } from "@/utils/geolocation";
//import useGeolocation from "@/hooks/useGeolocation";
import { useTranslation } from "react-i18next";
import { RootState } from "@/store/store";
import { useSelector } from 'react-redux';
import styled from "styled-components";

type InfoBlockType = {
    data: SinglePageData;
};

const StyledInfoBlock = styled.div`
    ul {
    list-style : none!important;
    }
`
const InfoBlock: React.FC<InfoBlockType> = ({ data }) => {

    const userLatitude = useSelector((state: RootState) => state.geolocation.latitude)
    const userLongitude = useSelector((state: RootState) => state.geolocation.longitude);
    const { t } = useTranslation(["common", "validation", "glossary"]);

    return (
        <StyledInfoBlock className="border border-primary rounded-lg flex-grow h-min">
            <div className="p-4 font-bold">{t("info", { ns: "glossary" })}</div>

            <div className="h-[1px] bg-primary w-full" />
            <ul className="!p-4 space-y-4 text-dark-blue">
                {data?.address && (
                    <li className="flex gap-4 text-sm">
                        <img src={routeicon} alt="icon" />
                        <a
                            href={
                                userLatitude !== null && userLongitude !== null
                                    ? `https://www.google.com/maps/dir/${userLatitude},${userLongitude}/${data.lat},${data.lng}`
                                    : `https://www.google.com/maps/place/${data.lat},${data.lng}`
                            }
                            target="_blank"
                            className="cursor-pointer"
                        >
                            {data?.address} {data?.address_num}{" "}
                            {data?.postal && `, ${data.postal}`}
                        </a>
                    </li>
                )}

                {data?.datetime_details && (
                    <li className="flex gap-4 text-sm">
                        <img src={calendar} />
                        <div>
                            {data.datetime_details.start_date}{" "}
                            {data.datetime_details.start_time} {data.datetime_details?.end_date || data.datetime_details?.end_time ? "-" : ""}{" "}
                            {data.datetime_details?.end_date}{" "}
                            {data.datetime_details?.end_time}
                        </div>
                    </li>
                )}
                {data?.telephone && (
                    <li className="-ml-0.5">
                        <a className="flex gap-4 text-sm" href={`tel:${data?.telephone}`}>
                            <img src={telephone} alt="icon" />
                            {data?.telephone}
                        </a>
                    </li>
                )}
                {data?.mobile && (
                    <li>
                        <a className="flex gap-4 text-sm" href={`tel:${data?.mobile}`}>
                            <img src={phone} alt="icon" />
                            {data?.mobile}
                        </a>
                    </li>
                )}

                {data?.website && (
                    <li>
                        <a
                            className="flex gap-4 text-sm"
                            href={data?.website}
                            target="_blank"
                        >
                            <img src={global} alt="icon" /> {data?.website}
                        </a>
                    </li>
                )}

                {data?.mail && (
                    <li>
                        <a
                            className="flex flex-row gap-4 text-sm"
                            href={`mailto:${data.mail}`}
                        >
                            <img src={mail} alt="icon" />
                            {data.mail}
                        </a>
                    </li>
                )}

                {data?.duration && (
                    <li className="flex gap-4 text-sm">
                        <img src={clock} alt="icon" /> {data?.duration}
                    </li>
                )}

                {data?.working_hours && (
                    <WorkingHours workingHours={data.working_hours} />
                )}

                {data?.socials && (
                    <li className="flex gap-4 text-sm pt-10">
                        {data.socials.map((item, ind) => (
                            <a key={ind} href={item.link} target="_blank">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: item.icon,
                                    }}
                                />
                            </a>
                        ))}
                    </li>
                )}
            </ul>
        </StyledInfoBlock>
    );
};

export default InfoBlock;
